module.exports = __webpack_public_path__ + "img/check-on.9ba2ef78.svg";